export default {
  "b2b.rezervace.casovy-plan.page-heading": "Timetable",
  "b2b.rezervace.vytvoreni.page-heading": "New Reservation"
};
